export default __webpack_public_path__ + "static/media/no_assignments.3cdd0d3a.gif";